import React from 'react';
import clsx from 'clsx';
import { SkeletonCardFields } from 'components/Loading';
import { makeStyles } from '@material-ui/styles';
import Rules from '../Rules';

import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  Box
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const Design = props => {
  const {
    className,
    staticContext,
    campaign,
    next,
    back,
    templates,
    paginatedTemplates,
    templateFilters,
    isTemplateDropdownLoading,
    isTemplateNameHydrationLoading,
    templateSelectedNamesByUuid,
    templateTags,
    showNav,
    ...rest
  } = props;
  const { goNext, goBack, isLoading } = campaign;
  const classes = useStyles();

  const SkeletonCardContent = props => {
    return (
      <CardContent>
        <Grid container spacing={0}>
          <SkeletonCardFields />
        </Grid>
      </CardContent>
    );
  };

  return (
    <div className={classes.root}>
      <Card {...rest} className={clsx(classes.root, className)}>
        <form autoComplete="off">
          <CardHeader
            subheader=""
            title="Template Rules"
            titleTypographyProps={{ variant: 'h1' }}
          />
          <Divider />
          {isLoading && <SkeletonCardContent />}
          {(!isLoading && (campaign.thisCampaign.hasMovedToNextStep || campaign.thisCampaign.uuid)) && (
            <CardContent>
              <Rules
                campaign={campaign}
                templates={templates}
                paginatedTemplates={paginatedTemplates}
                templateFilters={templateFilters}
                isTemplateDropdownLoading={isTemplateDropdownLoading}
                isTemplateNameHydrationLoading={isTemplateNameHydrationLoading}
                templateSelectedNamesByUuid={templateSelectedNamesByUuid}
                templateTags={templateTags}
              />
            </CardContent>
          )}
          {(next || back || showNav) && (
            <>
              <Divider />
              <CardActions className={classes.cardActions}>
                <Button
                  color="secondary"
                  variant="contained"
                  linkTo={back}
                  onClick={goBack}>
                  Back
                </Button>
                <Box flexGrow={1}>&nbsp;</Box>
                <Button
                  color="primary"
                  variant="contained"
                  linkTo={next}
                  onClick={goNext}>
                  Next
                </Button>
              </CardActions>
            </>
          )}
        </form>
      </Card>
    </div>
  );
};

export default Design;
